import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import api from "@/api";
import testPieChart from "@/components/chart/testPieChart";
import accuracyBarChart from "@/components/chart/accuracyBarChart.vue";
import numBarChart from "@/components/chart/numBarChart.vue";
import subjects from "@/utils/subjects";
export default {
  name: "ReviewAnswerCard",
  components: [testPieChart, accuracyBarChart, numBarChart],
  props: {
    examResult: {
      type: Object,
      default: () => {
        return {};
      }
    },
    questions: {
      type: Array,
      default: () => {
        return []; //[0,1,2,]
      }
    },
    costTime: {
      type: Number,
      default: 0
    },
    groupSize: {
      type: Number,
      default: 1
    },
    subject: {
      type: String,
      default: ''
    },
    showList: {
      type: Boolean,
      default: false
    },
    roomId: {
      type: String,
      default: ''
    },
    tplId: {
      type: String,
      default: ''
    }
  },
  computed: {
    rank() {
      const {
        rankUserCnt,
        rightRank,
        totalRightAns,
        totalQuestion
      } = this.subjectData;
      if (rankUserCnt == null) return '';
      if (Number(rankUserCnt) < 5) {
        // 与后端一致：正确数 / 总题数，未答题也计入分母，不使用图表修正后的正确率。
        const total = Number(totalQuestion);
        const correct = Number(totalRightAns);
        if (!Number.isFinite(total) || total <= 0 || !Number.isFinite(correct)) return 'D';
        if (correct * 100 >= total * 90) return 'A';
        if (correct * 100 >= total * 75) return 'B';
        if (correct * 100 >= total * 60) return 'C';
        return 'D';
      }
      if (rightRank == null || !Number.isFinite(Number(rightRank))) return '';
      const rankRatio = (Number(rightRank) + 1) / Number(rankUserCnt);
      if (rankRatio <= 0.1) return 'A';
      if (rankRatio <= 0.3) return 'B';
      if (rankRatio <= 0.7) return 'C';
      return 'D';
    },
    isClassTest() {
      return this.roomId && this.tplId;
    },
    total() {
      return this.questions.length;
    },
    rightAnswer() {
      return this.questions.filter(q => q == 0).length;
    },
    wrongAnswer() {
      return this.questions.filter(q => q == 1).length;
    },
    testData() {
      return {
        notDoNum: this.questions.filter(q => q == 2).length,
        rightAnswer: this.questions.filter(q => q == 0).length,
        wrongAnswer: this.questions.filter(q => q == 1).length
      };
    },
    accuracy() {
      if (this.rightAnswer + this.wrongAnswer === 0) return 0;
      return (this.rightAnswer / (this.rightAnswer + this.wrongAnswer) * 100).toFixed(2);
    },
    allUserAverageRightAccuracy() {
      if (this.subjectData.allUserAveRight + this.subjectData.allUserAveWrong === 0) return 0;
      const ratio = 100 * this.subjectData.allUserAveRight / (this.subjectData.allUserAveRight + this.subjectData.allUserAveWrong);
      if (ratio < 30) return (ratio * 2).toFixed(2);
      if (ratio < 50) return (ratio * 1.5).toFixed(2);
      if (ratio < 70) return (ratio * 1.2).toFixed(2);
      return ratio.toFixed(2);
    },
    averageRightAccuracy() {
      if (this.subjectData.averageRight + this.subjectData.averageWrong === 0) return 0;
      const ratio = 100 * this.subjectData.averageRight / (this.subjectData.averageRight + this.subjectData.averageWrong);
      if (ratio < 30) return (ratio * 2).toFixed(2);
      if (ratio < 50) return (ratio * 1.5).toFixed(2);
      return ratio.toFixed(2);
    },
    allUserAveRight() {
      if (!this.subjectData.allUserAveRight) return 0;
      const ratio = this.subjectData.allUserAveRight / this.total;
      if (ratio < 0.3) return (this.subjectData.allUserAveRight * 2).toFixed(2);
      if (ratio < 0.5) return (this.subjectData.allUserAveRight * 1.5).toFixed(2);
      return this.subjectData.allUserAveRight.toFixed(2);
    }
  },
  watch: {
    subject() {
      this.init();
    }
  },
  data() {
    return {
      subjectData: {},
      dialogTableVisible: true,
      infoMap: subjects.infoMap,
      classTotal: 0,
      doneNum: 0,
      rankNo: 0,
      user: {}
    };
  },
  methods: {
    secondsToMMSS(seconds) {
      const minutes = Math.floor(seconds / 60);
      const remainingSeconds = seconds % 60;
      const formattedMinutes = String(minutes).padStart(2, '0');
      const formattedSeconds = String(remainingSeconds).padStart(2, '0');
      return `${formattedMinutes}:${formattedSeconds}`;
    },
    async init() {
      this.subjectData = await api.getUserExamAverageAndRank({
        subjectStr: this.subject
      });
    },
    async getClassData() {
      if (this.roomId && this.tplId) {
        const res = await api.getClassAnswerData({
          roomId: this.roomId,
          tplId: this.tplId,
          state: 0,
          page: 0,
          pageSize: 50
        });
        const list = res.list;
        this.classTotal = list.length;
        let doneList = list.filter(item => item.session && item.session.state.indexOf('END') >= 0);
        this.doneNum = doneList.length;
        doneList = doneList.sort((a, b) => b.session.rightAnswerCnt - a.session.rightAnswerCnt);
        console.log(doneList);
        doneList.forEach((item, index) => {
          if (item.user.phone === this.user?.phone) {
            this.rankNo = index + 1;
          }
        });
      }
    }
  },
  mounted() {
    this.init();
    this.getClassData();
    api.getUserInfo().then(ret => {
      this.user = ret.info;
    });
  },
  unmounted() {}
};